import { configureStore } from '@reduxjs/toolkit';

import loginReducer from '../slices/loginSlice';
import userReducer from '../slices/userSlice';
import myAdsReducer from '../slices/myAdsSlice';
import notificationReducer from '../slices/notificationSlice';
import supportReducer from '../slices/supportSlice';
import requestReducer from '../slices/requestSlice';
import menuSlice from '../slices/commonSlice';

export default configureStore({
    reducer: {
        emailLogin: loginReducer,
        user: userReducer,
        myAds: myAdsReducer,
        notification: notificationReducer,
        support: supportReducer,
        request: requestReducer,
        menuReducer: menuSlice
    }
});
